let rows = {}
const elements = document.querySelectorAll(
    '.article-profile .article-elements .article-element.sizable-card',
)

const expandRow = (row) => {
    if (!rows[row]) {
        return
    }
    rows[row].forEach((card) => {
        card.classList.remove('is-overflowing')
        card.classList.add('is-expanded')
    })
}

let previousWindowWidth = null
const updateCardLayout = () => {
    const windowWidth = window.innerWidth
    if (previousWindowWidth && previousWindowWidth === windowWidth) {
        return
    }
    previousWindowWidth = windowWidth

    rows = {}
    elements.forEach((card) => {
        const infoContainer = card.querySelector('.card-information')
        if (infoContainer.scrollHeight > infoContainer.offsetHeight) {
            if (infoContainer.scrollHeight > infoContainer.offsetHeight + 16) {
                card.classList.add('is-overflowing')
            } else {
                card.classList.add('is-expanded')
            }
        }
        const theTop = Math.round(card.offsetTop)
        if (!rows[theTop]) {
            rows[theTop] = []
        }
        rows[theTop].push(card)
        const cardBody = infoContainer.querySelector('.card-body')
        if (cardBody) {
            const clicker = () => {
                expandRow(theTop)
                cardBody.removeEventListener('click', clicker)
            }
            cardBody.addEventListener('click', clicker)
        }
    })
}

window.requestAnimationFrame(() => {
    updateCardLayout()
})

let resizeAnimationFrame = null
let resizeTimeout = null
window.addEventListener('resize', () => {
    if (resizeTimeout) {
        clearTimeout(resizeTimeout)
    }
    if (resizeAnimationFrame) {
        cancelAnimationFrame(resizeAnimationFrame)
    }
    resizeTimeout = setTimeout(() => {
        resizeAnimationFrame = requestAnimationFrame(updateCardLayout)
    }, 100)
})
